
<form #form="ngForm" (ngSubmit)="onSubmit(form)">

  <mat-dialog-content class="m-0 px-3 py-4" style="max-height: 40vh">

    <ng-container *ngIf="ta_revised_workflow.step_no">
      <h6>Step No</h6>
      <p>{{ta_revised_workflow.step_no}}</p>
    </ng-container>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Description</mat-label>
      <textarea
        rows="8"
        matInput
        placeholder="Description"
        [(ngModel)]="ta_revised_workflow.description"
        name="description"
        required
        #description
        matTooltip="Enter a step description.">
      </textarea>
      <mat-hint>Please enter a step description.</mat-hint>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">

    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress || !ta_revised_workflow.id"
      color="primary"
      type="button"
      id="save"
      class="my-2 ml-1 mr-2"
      (click)="onSubmit(form, false)">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="button"
      id="save_close"
      class="my-2 ml-1 mr-2"
      (click)="onSubmit(form)">
      <mat-icon>save</mat-icon>
      Save & Close
    </button>

    <app-file-browse-button
      (selectedFiles)="onSelectFiles($event)"
      (afterDialogClosedEvent)="onSubmit(form, false)"
      parentObjectType="task_analysis_revised_workflow"
      [parentObjectId]="ta_revised_workflow.id"
      [filesCount]="ta_revised_workflow.files?.length">
    </app-file-browse-button>

  </mat-dialog-actions>

</form>


